module.exports = __webpack_public_path__ + "media/images/entrepreneur-41f6a1ed.png";